export default "__VITE_ASSET__4968ae77__"